export const contactDataAPIs = {
  get: {
    url: 'contact/all',
    method: 'get',
    isAuthEnabled: true,
  },
};
